import * as Api from '@ViewModels';
import { useCallback } from 'react';
import { buildMeetingUrlForContact } from '../utils/meetingUrlBuilder';
import { getFirstPublishedMeetingConfig } from './useMeetingConfigsForUser';

/**
 * Custom hook to handle booking meetings for contacts with different users
 * Encapsulates the logic for fetching meeting configs and building URLs
 */
export function useBookMeetingForContact(
	contact: Api.IContact,
	currentUserMeetingConfigs: Api.MeetingConfigViewModel[] | undefined
) {
	const bookMeetingWithUser = useCallback(
		async (_selectedUser: Api.IUser) => {
			try {
				// Use existing meeting configs directly
				const firstPublishedMeeting = getFirstPublishedMeetingConfig(currentUserMeetingConfigs);
				if (firstPublishedMeeting) {
					const url = buildMeetingUrlForContact(firstPublishedMeeting, {
						contactId: contact.id,
					});
					if (url) {
						window.open(url, '_blank');
					}
				}
			} catch (error) {
				console.error('Failed to book meeting for contact:', error);
			}
		},
		[contact.id, currentUserMeetingConfigs]
	);

	const bookMeetingWithMeetingConfigs = useCallback(
		(meetingConfigs: Api.MeetingConfigViewModel[] | undefined, selectedUserId?: string) => {
			const firstPublishedMeeting = getFirstPublishedMeetingConfig(meetingConfigs);
			if (firstPublishedMeeting) {
				const url = buildMeetingUrlForContact(firstPublishedMeeting, {
					contactId: contact.id,
					selectedUserId,
				});
				if (url) {
					window.open(url, '_blank');
				}
			}
		},
		[contact.id]
	);

	return {
		bookMeetingWithUser,
		bookMeetingWithMeetingConfigs,
	};
}
